/* import __COLOCATED_TEMPLATE__ from './business-management.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { LegalEntitiesBusinessEntityType } from '@banking/api/utils/business-types';
import { Validation } from '@banking/ui/utils/validation';
import { inject as service } from '@ember/service';
import { formatBps } from '@capital/intl/utils';
import { MAX_OWNERSHIP_BPS, OTHER_OWNERS_BREAKPOINT_BPS } from '@banking/ui/workflows/onboarding-kyb/state';
import { TextField } from 'field-kit';
import PercentageFormatter from '@banking/ui/utils/field-kit-formatters/percentage-formatter';
let BusinessManagement = (_class = class BusinessManagement extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "ownershipBps", _descriptor2, this);
    _initializerDefineProperty(this, "isManager", _descriptor3, this);
    _initializerDefineProperty(this, "otherSignificantOwners", _descriptor4, this);
    _defineProperty(this, "hasValidated", false);
    _initializerDefineProperty(this, "isManagerValidation", _descriptor5, this);
    _initializerDefineProperty(this, "ownershipBpsValidation", _descriptor6, this);
    _initializerDefineProperty(this, "otherSignificantOwnersValidation", _descriptor7, this);
    _initializerDefineProperty(this, "features", _descriptor8, this);
    this.isManager = this.args.isManager;
    this.otherSignificantOwners = this.args.hasSignificantOwners;
    this.ownershipBps = this.args.ownershipBps;
  }
  get entityTypeLabel() {
    // eslint-disable-next-line square/no-translation-key-interpolation
    return this.intl.t(`banking.enums.entityType.${LegalEntitiesBusinessEntityType[this.args.entityType]}`);
  }
  get ownershipOptions() {
    const options = [];
    for (let index = MAX_OWNERSHIP_BPS; index >= 0; index -= 100) {
      options.push({
        value: index,
        label: formatBps(index, this.intl)
      });
    }
    return options;
  }
  get showOtherOwnerQuestion() {
    return Boolean(this.ownershipBps == null || this.ownershipBps <= OTHER_OWNERS_BREAKPOINT_BPS);
  }
  get formData() {
    return {
      isManager: this.isManager,
      ownershipBps: this.ownershipBps,
      hasSignificantOwners: this.otherSignificantOwners
    };
  }
  updateRole(value) {
    this.isManager = value;
    if (this.hasValidated) {
      this.validate(this.formData);
    }
  }
  updateHasSignificantOwners(value) {
    this.otherSignificantOwners = value;
    if (this.hasValidated) {
      this.validate(this.formData);
    }
  }
  updateOwnership(event) {
    const value = Number(event.detail.value);
    this.ownershipBps = value;
    if (this.hasValidated) {
      this.validate(this.formData);
    }
    if (value > 75_00) {
      this.updateHasSignificantOwners(false);
    }
  }
  validate(data) {
    this.isManagerValidation = new Validation();
    if (data.isManager == null) {
      this.isManagerValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.notSelect'));
    }
    this.ownershipBpsValidation = new Validation();
    if (data.ownershipBps == null) {
      if (this.features.isEnabled('banking/enable_kyb_ownership_input_text')) {
        this.ownershipBpsValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.ownershipBpsNotInput'));
      } else {
        this.ownershipBpsValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.ownershipBpsNotSelect'));
      }
    } else {
      if (!(data.ownershipBps >= 0 && data.ownershipBps <= MAX_OWNERSHIP_BPS)) {
        this.ownershipBpsValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.ownershipBpsInvalid'));
      }
    }
    this.otherSignificantOwnersValidation = new Validation();
    if (this.showOtherOwnerQuestion && data.hasSignificantOwners == null) {
      this.otherSignificantOwnersValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.notSelect'));
    }
    this.hasValidated = true;
    return this.isManagerValidation.isValid && this.ownershipBpsValidation.isValid && this.otherSignificantOwnersValidation.isValid;
  }
  submit(event) {
    event.preventDefault();
    const formData = this.formData;
    if (!this.validate(formData)) {
      return;
    }
    if (formData.hasSignificantOwners === undefined) {
      formData.hasSignificantOwners = false;
    }
    this.args.onSubmit(formData);
  }
  async initializeFieldKit(marketInputTextElement) {
    const inputElement = await marketInputTextElement.getInputElement();
    const formatter = new PercentageFormatter();
    const fieldKit = new TextField(inputElement, formatter);
    const initialValue = this.ownershipBps ? this.ownershipBps / 100 : null;
    if (initialValue != null) {
      // eslint-disable-next-line require-atomic-updates
      marketInputTextElement.value = formatter.format(initialValue);
    }
    const textDidChange = field => {
      const ownershipBpsVal = Number(field.value());
      this.ownershipBps = Math.round(ownershipBpsVal * 100);

      /** validate the input value */
      this.hasValidated = true;
      if (field.value() === '') {
        this.ownershipBpsValidation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessManagement.error.ownershipBpsNotInput'));
      } else {
        this.ownershipBpsValidation = new Validation();
        this.hasValidated = false;
      }
      if (ownershipBpsVal > 75) {
        this.updateHasSignificantOwners(false);
      }
    };
    const textFieldDidEndEditing = field => {
      if (this.ownershipBps != null) {
        field.setValue(Number(field.value()).toString());
        this.ownershipBpsValidation = new Validation();
        this.hasValidated = false;
      }
    };
    fieldKit.setDelegate({
      textDidChange,
      textFieldDidEndEditing
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ownershipBps", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isManager", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "otherSignificantOwners", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isManagerValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Validation();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "ownershipBpsValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Validation();
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "otherSignificantOwnersValidation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Validation();
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateRole", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateHasSignificantOwners", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateHasSignificantOwners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateOwnership", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateOwnership"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _class);
export { BusinessManagement as default };